// API configuration for different environments
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

// Helper function to build full API URLs
export const getApiUrl = (endpoint) => {
    // Ensure endpoint starts with /
    const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
    return `${API_BASE_URL}${normalizedEndpoint}`;
};

// Export the base URL for direct use if needed
export { API_BASE_URL };